// pages/ReportDetailsModal.jsx
import { XMarkIcon } from "@heroicons/react/24/outline";
import Loading from "../loading";

const ReportDetailsModal = ({
  selectedReport,
  reportDetails,
  detailsLoading,
  onClose,
  onStatusChange,
  onRefresh,
}) => {
  const question = selectedReport?.questionId || {};

  const statusOptions = [
    { value: "pending", label: "در انتظار بررسی" },
    { value: "reviewed", label: "در حال بررسی" },
    { value: "accepted", label: "تأیید شده" },
    { value: "rejected", label: "رد شده" },
    { value: "fixed", label: "اصلاح شده" },
  ];

  const getStatusColor = (status) => {
    const map = {
      pending: "bg-yellow-100 text-yellow-700",
      reviewed: "bg-blue-100 text-blue-700",
      accepted: "bg-green-100 text-green-700",
      rejected: "bg-red-100 text-red-700",
      fixed: "bg-purple-100 text-purple-700",
    };
    return map[status] || "bg-gray-100 text-gray-700";
  };

  const getStatusLabel = (status) => {
    const map = {
      pending: "در انتظار بررسی",
      reviewed: "در حال بررسی",
      accepted: "تأیید شده",
      rejected: "رد شده",
      fixed: "اصلاح شده",
    };
    return map[status] || status;
  };

  return (
    <div className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden">
      {/* هدر */}
      <div className="flex justify-between items-center p-6 border-b border-gray-200 bg-gray-50">
        <h2 className="text-xl font-bold text-gray-800">جزئیات گزارش</h2>
        <button
          onClick={onClose}
          className="p-1 hover:bg-gray-200 rounded-full transition-colors"
        >
          <XMarkIcon className="w-6 h-6 text-gray-500" />
        </button>
      </div>

      {detailsLoading ? (
        <div className="p-12 flex justify-center">
          <Loading />
        </div>
      ) : selectedReport ? (
        <div className="p-6 space-y-6">
          {/* عنوان گزارش */}
          <div>
            <h3 className="text-sm font-medium text-gray-500 mb-1">
              عنوان گزارش
            </h3>
            <p className="text-lg font-semibold text-gray-800">
              {selectedReport.title || "بدون عنوان"}
            </p>
          </div>

          {/* وضعیت */}
          <div>
            <h3 className="text-sm font-medium text-gray-500 mb-1">وضعیت</h3>
            <div className="flex items-center gap-4 flex-wrap">
              <span
                className={`px-3 py-1 text-sm rounded-full font-medium ${getStatusColor(
                  selectedReport.status,
                )}`}
              >
                {getStatusLabel(selectedReport.status)}
              </span>
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">تغییر وضعیت:</span>
                <select
                  value={selectedReport.status}
                  onChange={(e) =>
                    onStatusChange(selectedReport._id, e.target.value)
                  }
                  className="px-3 py-1 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                >
                  {statusOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* اطلاعات سوال */}
          <div className="border-t border-gray-200 pt-4">
            <h3 className="text-sm font-medium text-gray-500 mb-3">
              اطلاعات سوال
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <span className="text-xs text-gray-400">درس</span>
                <p className="font-medium">{question.lessonName || "نامشخص"}</p>
              </div>
              <div>
                <span className="text-xs text-gray-400">پایه</span>
                <p className="font-medium">{question.grade || "نامشخص"}</p>
              </div>
              <div>
                <span className="text-xs text-gray-400">کتاب</span>
                <p className="font-medium">{question.book || "نامشخص"}</p>
              </div>
              <div>
                <span className="text-xs text-gray-400">تاریخ ارسال</span>
                <p className="font-medium">
                  {new Date(selectedReport.created_at).toLocaleString("fa-IR", {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </p>
              </div>
            </div>
          </div>

          {/* متن کامل سوال */}
          <div className="border-t border-gray-200 pt-4">
            <h3 className="text-sm font-medium text-gray-500 mb-2">متن سوال</h3>
            <div
              className="p-4 bg-gray-50 rounded-lg border border-gray-200 text-gray-700 text-sm leading-relaxed"
              dangerouslySetInnerHTML={{
                __html: question.content || "متن سوال موجود نیست",
              }}
            />
          </div>

          {/* متن کامل گزارش */}
          <div className="border-t border-gray-200 pt-4">
            <h3 className="text-sm font-medium text-gray-500 mb-2">
              متن گزارش
            </h3>
            <div className="p-4 bg-yellow-50 rounded-lg border border-yellow-200 text-gray-700 text-sm leading-relaxed">
              {selectedReport.reportText || "متن گزارش موجود نیست"}
            </div>
          </div>
        </div>
      ) : (
        <div className="p-12 text-center text-gray-500">
          اطلاعات گزارش در دسترس نیست.
        </div>
      )}
    </div>
  );
};

export default ReportDetailsModal;
